import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import DefRoutes from "../../../routes/routes.json";
import t from "../../../i18n/i18n";

import Membership from "../../../components/membership/membership";

function Aside() {
  const { user } = useSelector((store) => store.auth);
  const { avatar, credits, name, nickname } = user;

  const { pathname } = window.location;

  return (
    <aside>
      <div className="profile-box gutter-65">
        <div className="user-name-info">
          <span className="user-thumb">
            <img src={avatar || "/images/user-thumn-m.png"} alt="" />
          </span>
          <div className="user-name-title">
            {nickname && <span className="name">{nickname}</span>}
            <small>@{name}</small>
          </div>
        </div>
      </div>
      <div className="user-credit-box gutter-65">
        <div className="credit-data">
          <span className="icon">
            <img src="/images/credit-ico.png" alt="" />
          </span>
          <h6>{credits || 0}</h6>
          <small>{t("General.Credits")}</small>
        </div>
      </div>
      <div className="membership-box gutter-65">
        <Membership user={user} />
      </div>
      <nav className="side-nav gutter-65">
        <ul>
          <li className={DefRoutes.Profile === pathname && "active"}>
            <Link to={DefRoutes.Profile}>
              <span className="icon">
                <img src="/images/user-icon.png" alt="" />
              </span>
              {t("Menu.Profile")}
            </Link>
          </li>
          <li className={DefRoutes.ChangePassword === pathname && "active"}>
            <Link to={DefRoutes.ChangePassword}>
              <span className="icon">
                <img src="/images/lock-icon.png" alt="" />
              </span>
              {t("Menu.PasswordChange")}
            </Link>
          </li>
          <li className={DefRoutes.LoginSocial === pathname && "active"}>
            <Link to={DefRoutes.LoginSocial}>
              <span className="icon">
                <img src="/images/logout-icon.png" alt="" />
              </span>
              {t("Menu.SocialConnect")}
            </Link>
          </li>
          <li>
            <Link to={DefRoutes.RechargeCenter}>
              <span className="icon">
                <img src="/images/doller-icon.png" alt="" />
              </span>
              {t("Menu.RechargeCenter")}
            </Link>
          </li>
          <li>
            <Link to={DefRoutes.LoyalMember}>
              <span className="icon">
                <img src="/images/crown-small-ico.png" alt="" />
              </span>
              {t("General.LoyalMember")}
            </Link>
          </li>
          <li>
            <Link to={DefRoutes.Support}>
              <span className="icon">
                <img src="/images/face-icon.png" alt="" />
              </span>
              {t("Menu.Suport")}
            </Link>
          </li>
          <li>
            <Link to={DefRoutes.Logout}>
              <span className="icon">
                <img src="/images/sair-icon.png" alt="" />
              </span>
              {t("Menu.Exit")}
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
}

export default Aside;
